import React from 'react';
import { i18n } from '@lt/localization';
import CustomBooleanFilterGroup from '../components/CustomBooleanFilterGroup';

import type { IFilter } from '../types';

const FilterFamilyWithKids = ({
  className = '',
  isMobile = false,
  ...props
}: IFilter): JSX.Element => (
  <CustomBooleanFilterGroup
    className={className}
    isMobile={isMobile}
    {...props}
    Filter={{
      filterLabel: i18n.t('filters.kids.title'),
      FILTER_NAMES,
      customFilters: Object.keys(FILTER_NAMES),
    }}
  />
);

const FILTER_NAMES = {
  nanny: i18n.t('filters.kids.nanny'),
  kids_menu: i18n.t('filters.kids.menu'),
  kids_club: i18n.t('filters.kids.club'),
  kids_pool: i18n.t('filters.kids.pool'),
};

export default Object.assign(FilterFamilyWithKids, {
  filterName: 'family_with_kids',
  filterLabel: i18n.t('filters.kids.title'),
  FILTER_NAMES,
  customFilters: Object.keys(FILTER_NAMES),
});
